/* eslint-disable */

import Vue from 'vue'
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

export const placa = {
  mask: 'AAA#CC#',
  tokens: {
    C: {
      pattern: /[0-9a-zA-Z]/,
      transform: function(v) {
        return v.toLocaleUpperCase()
      }
    },
    A: {
      pattern: /[a-zA-Z]/,
      transform: function(v) {
        return v.toLocaleUpperCase()
      }
    },
    '#': { pattern: /\d/ }
  }
}
